import { WhichWeightAPI } from "WhichWeightAPI";
import { GetActiveWorkout } from "redux/slices/activeWorkout";

export const GetCurrentPhaseTaperData = (activeWorkout, phase) => {
    const phaseTaperDataExists = (
        phase.taperData && 
        phase.taperData.source === 'phase-load-adjustment-override' && 
        phase.taperData.overrideApplied
    )

    if (phaseTaperDataExists) return phase.taperData

    return activeWorkout.taperData
}

export const IsLoadDifficultyFeedbackEnabledForExercise = (exercise) => {

    return (
        exercise.setUnit === "reps" &&
        exercise.exerciseType === "recommendation" && 
        !exercise.continuousOverride
    )

}

export const GetExerciseLocalCompletedSets = (taperData, exercise) => {
    const localCompletedSets = []

    // Loop over each set
    for (let setIndex = 0; setIndex < exercise.sets.length; setIndex++) {

        // If the set is completed, created an completion object and add to localCompletedSets array
        if (exercise.sets[setIndex].completedSetData.completed === true) {
            var newLocalCompletedSet = {
                'exerciseId': exercise.id,
                'exerciseName': exercise.name,
                'currentSet': setIndex + 1,
                'setsAssigned': exercise.sets.length,
                'weightRecommendation': exercise.sets[setIndex].recommendationData.weightRecommendation,
                'weightRecommendationRounded': exercise.sets[setIndex].recommendationData.weightRecommendationRounded,
                'formulaTag': exercise.sets[setIndex].recommendationData.formulaTag,
                'difficulty': exercise.sets[setIndex].completedSetData.difficulty,
                'setUnitsCompleted': exercise.sets[setIndex].completedSetData.setUnitsCompleted,
                'setUnitsAssigned': exercise.setUnit === 'reps' ? exercise.sets[setIndex].reps : exercise.sets[setIndex].seconds,
                'override': exercise.sets[setIndex].completedSetData.override,
                'taper': taperData.useTaper ? 1 : 0,
                'taperDampener': taperData.taperDampener,
                'completeDate': exercise.sets[setIndex].completedSetData.completedTimestamp
            }

            // console.log(newLocalCompletedSet)

            localCompletedSets.push(newLocalCompletedSet)
        }

    }

    return localCompletedSets
}

export const LoadSetWeightRecommendation = async (
    dispatch, 
    activeWorkoutState,
    profileType,
    groupId,
    athleteId,
    taperData,
    phaseIndex, 
    exerciseIndex, 
    setIndex,
    localCompletedSets,
    setActiveWorkoutIncompleteSetInfo
) => {

    const activeWorkout = GetActiveWorkout(activeWorkoutState, profileType, groupId, athleteId)
    
    if (!activeWorkout) return

    const exercise = activeWorkout.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex]
    const set = exercise.sets[setIndex]

    // Initial set data
    // Defaults to bodyweight object
    const incompleteSetInitialData = {
        profileType: profileType,
        groupId: groupId,
        athleteId: athleteId,
        phaseIndex: phaseIndex, 
        exerciseIndex: exerciseIndex, 
        setIndex: setIndex,
        weightRecommendation: 0,
        weightRecommendationRounded: 0,
        formulaTag: "bodyweight",
        equipmentDetails: null
    }

    // Initial data for continuous override exercise
    if (exercise.continuousOverride){
        incompleteSetInitialData.weightRecommendation = exercise.continuousOverrideWeight
        incompleteSetInitialData.weightRecommendationRounded = exercise.continuousOverrideWeight
        incompleteSetInitialData.formulaTag = "continuous-override"
    }

    // Initial data for recommendation exercises
    if (!exercise.continuousOverride && exercise.exerciseType === "recommendation"){

        try {

            var jsonBody = null

            if (profileType === 'group') {
                jsonBody = { 
                    groupId: groupId,
                    weekOfTheYearKey: activeWorkout.weekOfTheYearKey,
                    workoutTemplateKey: activeWorkout.workoutTemplateKey,
                    phaseIndex: parseInt(phaseIndex),
                    slotIndex: parseInt(exerciseIndex),
                    exerciseId: exercise.id,
                    reps: set.reps,
                    taper: taperData.useTaper ? 1 : 0,
                    taperDampener: taperData.taperDampener,
                    localCompletedSets: JSON.stringify(localCompletedSets)
                }
            }

            if (profileType === 'individual') {
                jsonBody = { 
                    userId: athleteId,
                    weekOfTheYearKey: activeWorkout.weekOfTheYearKey,
                    workoutTemplateKey: activeWorkout.workoutTemplateKey,
                    phaseIndex: parseInt(phaseIndex),
                    slotIndex: parseInt(exerciseIndex),
                    exerciseId: exercise.id,
                    reps: set.reps,
                    taper: taperData.useTaper ? 1 : 0,
                    taperDampener: taperData.taperDampener,
                    localCompletedSets: JSON.stringify(localCompletedSets)
                }
            }

            // console.log(jsonBody)

            const result = await WhichWeightAPI("PROGRAM", "GET", "/weight_recommendation", jsonBody);

            // console.log(result.data.data)
            
            // Set values from the backend
            incompleteSetInitialData.weightRecommendation = result.data.data.weightRecommendation
            incompleteSetInitialData.weightRecommendationRounded = result.data.data.weightRecommendationRounded
            incompleteSetInitialData.formulaTag = result.data.data.formulaTag
            incompleteSetInitialData.equipmentDetails = result.data.data.equipmentDetails

        } catch (error) {
            console.log(error);

            // DEFAULT VALUES
            incompleteSetInitialData.weightRecommendation = 15
            incompleteSetInitialData.weightRecommendationRounded = 15
            incompleteSetInitialData.formulaTag = 'error-handling-default'
            incompleteSetInitialData.equipmentDetails = null
        }

    }

    dispatch(setActiveWorkoutIncompleteSetInfo(incompleteSetInitialData));
}

export const InitAssessmentSetWeightRecommendation = async (
    dispatch, 
    activeAssessment, 
    phaseIndex, 
    exerciseIndex, 
    setIndex, 
    dispatchFunction,
    userId
) => {
    
    const exercise = activeAssessment.workoutTemplate.phases[phaseIndex].exercises[exerciseIndex]

    // Initial set data
    // Defaults to bodyweight object
    const incompleteSetInitialData = {
        phaseIndex: phaseIndex, 
        exerciseIndex: exerciseIndex, 
        setIndex: setIndex,
        weightRecommendation: 0,
        weightRecommendationRounded: 0,
        formulaTag: "bodyweight",
        equipmentDetails: null
    }

    // Initial data for continuous override exercise
    if (exercise.continuousOverride){
        incompleteSetInitialData.weightRecommendation = exercise.continuousOverrideWeight
        incompleteSetInitialData.weightRecommendationRounded = exercise.continuousOverrideWeight
        incompleteSetInitialData.formulaTag = "continuous-override"
    }

    // Send incomplete set initial data to store
    dispatch(dispatchFunction({ userId, ...incompleteSetInitialData }));

}

export const AreAllSetsForAnExerciseIncomplete = (profileType, exercise) => { 

    if (profileType === 'group') {

        for (const set of exercise.sets) {

            // If any base set completed data is true, return false

            if (set.completedSetData.completed === true) {
                return false
            }

            // If any athlete individual set completed data is true, return false

            for (const athleteId of Object.keys(set.groupIndividualCompletedSetData)) {
                if (set.groupIndividualCompletedSetData[athleteId].completed === true) {
                    return false
                }
            }
        }

        return true
    }

    if (profileType === 'individual') {
        return exercise.sets.every((set) => !set.completedSetData.completed)
    }

    return false
}

export const SwapExercise = (
    dispatch,
    profileType,
    groupId,
    athleteId,
    phaseIndex,
    exerciseIndex,
    swapType,
    swapExercise,
    swapActiveWorkoutExercise = () => {},
    MutateRemainingSets = () => {},
) => {
    const swapExercisePayload = {
        profileType: profileType,
        groupId: groupId,
        athleteId: athleteId,
        phaseIndex: phaseIndex,
        exerciseIndex: exerciseIndex,
        swapType: swapType,
        swapExercise: swapExercise
    }

    dispatch(swapActiveWorkoutExercise(swapExercisePayload))

    const mutatePayload = {
        phaseIndex: phaseIndex,
        exerciseIndex: exerciseIndex,
        mutationKey: 'recalculate-weight-recommendation'
    }

    MutateRemainingSets(mutatePayload)
}

export const UndoExerciseSwap = (
    dispatch,
    profileType,
    groupId,
    athleteId,
    phaseIndex,
    exerciseIndex,
    undoExerciseSwap = () => {},
    MutateRemainingSets = () => {}
) => {
    const undoPayload = {
        profileType: profileType,
        groupId: groupId,
        athleteId: athleteId,
        phaseIndex: phaseIndex,
        exerciseIndex: exerciseIndex,
    }

    dispatch(undoExerciseSwap(undoPayload))

    const mutatePayload = {
        phaseIndex: phaseIndex,
        exerciseIndex: exerciseIndex,
        mutationKey: 'recalculate-weight-recommendation'
    }

    MutateRemainingSets(mutatePayload)
}
